module.exports = __webpack_public_path__ + "static/media/CONT.174821c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CONT.jpg
// module id = 1722
// module chunks = 1